(function () {
  const cards: NodeListOf<HTMLElement> = document.querySelectorAll('.category-card');

  if (cards.length >= 1) {
    cards.forEach((card) => {
      card.addEventListener('click', (evt) => {
        const linkElm = evt.currentTarget as HTMLElement;
        const link = linkElm.querySelector<HTMLAnchorElement>('a');
        if (link) {
          link.click();
        }
      });
    });
  }
})();
